import * as React from 'react';
import Navbar from 'Screens/Layout/Common/Components/Navbar';

// Assets
import '../Assets/MissionPage.sass';

const Mission = () => (
    <React.Fragment>
        <Navbar navbarClass='navbar-light'/>
        <div className='container'>
            <div className='row'>
                <div className='about-header'>
                    <strong>Our Mission: </strong>
                    <span>Accessible quality technical education for all, through personalized, flexible, and hands-on
                        complete learning.</span>
                </div>
                <hr/>
                <p>
                    There is tremendous scope today for improving the accessibility of quality technical education in many
                    parts of the world, specifically in India. Our mission is to work toward this through a combination of
                    online technical content, mixed with active learning: thinking and  problem solving while learning for
                    effective understanding.  Our model encourages personalized self-learning, in addition to group
                    learning, as well as instructor-guided flipped classrooms.
            </p>
                <div>
                    <strong>Features:</strong>
                    <p>
                        The platform has been designed to mimic a classroom setting, yet providing enough flexibility so
                        that students can study the material at their own pace and chosen time/group.
                </p>
                    <ul>
                        <li>The interactivity of classroom discussions has been captured via embedding questions/activities
                        and feedback as part of the videos itself.</li>
                        <li>The duration of the videos has been kept short to retain student's focus.</li>
                        <li>All material has been organized into chapters which in turn are made of sections. A section
                            hosts all material related to a concept in one place: videos, slides, reference material,
                            practice problems, activities all on same page.</li>
                    </ul>
                </div>
                <p>The end result of all this is what we term <strong>"PFC" learning</strong>.</p>
                <div>
                    <strong>Personalized Learning:</strong>
                    <ul>
                        <li>Unlike a classroom setting, it is as if the instructor is teaching just you.</li>
                        <li>Unlike a classroom setting, everyone gets to answer questions during instruction without fear of
                        embarrassment.</li>
                    </ul>
                </div>
                <div>
                    <strong>Flexible Learning:</strong>
                    <ul>
                        <li>Unlike fixed class timings, when it comes to learning, students get to chose the time, place and
                        group</li>
                        <li>Unlike class room setting, student can set their own pace: take as much time to view or answer a
                        question</li>
                        <li>Unlike class room setting, student can watch the video as many times until the concept is really
                        clear.</li>
                    </ul>
                </div>
                <div>
                    <strong>Complete Learning:</strong>
                    <ul>
                        <li>Since each concept is complete, a student can move ahead only after complete mastery of concept.
                            In a classroom setting, this is not possible since instructor may cover multiple concepts in one
                            lecture and practice is often outside lecture hours. Here, one can intersperse video watching
                            with practice.</li>
                    </ul>
                </div>
                <hr/>
            </div>
        </div>
    </React.Fragment>
);

export default Mission;
